export var InternalHandlers;
(function (InternalHandlers) {
    InternalHandlers["ApplyTemplate"] = "apply-template";
    InternalHandlers["GetTemplate"] = "get-template";
    InternalHandlers["SaveTemplate"] = "save-template";
})(InternalHandlers || (InternalHandlers = {}));
//# sourceMappingURL=types.js.map